<template>
  <div>
    <!-- 搜索-->
    <el-form :inline='true' label-position='right' class='table-search'>
      <el-form-item label='' prop='group_id'>
        <CompanySelect :multiple='true' @handleSelect='handleDept' />
      </el-form-item>
      <el-form-item>
        <el-select @change="handleQuery" filterable clearable placeholder="红人检索：输入关键字"
                   v-model="selectInfo.artist_id">
          <el-option :key="index" :label="item.nickname" :value="item.artist_id" v-for="(item,index) in kolList">
            <span class="float-left"> {{ item.nickname }} </span>
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-input @change="handleQuery" v-model='selectInfo.keywords' placeholder='内容主题' clearable />
      </el-form-item>
      <el-form-item>
        <el-button @click='handleQuery' type='primary' icon='el-icon-search'>查询</el-button>
      </el-form-item>
      <el-form-item>
        <el-button v-if="userPermissions.indexOf('artist_pic_text_record_add') > -1" type="primary"
                   class="ml-5" @click="addShowView">新增数据
        </el-button>
      </el-form-item>
      <el-form-item style="float: right">
        <export-btn type='warning' ref='refExportTemplate'
                    :can-export='true'
                    :lint-title='`导出`'
                    class="download"
                    @export='exportDownload()' />

        <el-button v-if="userPermissions.indexOf('artist_pic_text_record_add') > -1" icon='el-icon-upload2'
                   type='primary' class="ml-10" @click='openImport=true'>导入
        </el-button>

        <el-button v-if="userPermissions.indexOf('artist_pic_text_record_delete') > -1" icon='el-icon-delete'
                   type='warning' class="ml-10" @click='batchDelete'>批量删除
        </el-button>
      </el-form-item>
    </el-form>
    <div class="default-table">
      <el-table v-loading="isLoading" :data="dataList" ref="multipleTable" row-key="id" border @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55" />
        <el-table-column align="center" label="序号" type="index" width="60" />
        <el-table-column align="center" label="部门—组" prop="dept_nm" show-overflow-tooltip />
        <el-table-column align="center" label="红人昵称" prop="nickname" show-overflow-tooltip />
        <el-table-column align="center" label="编辑" prop="editor" show-overflow-tooltip />
        <el-table-column align="center" label="更新日期" prop="upd_at" show-overflow-tooltip />
        <el-table-column align="left" label="内容主题" prop="theme"  header-align="center" width="500" show-overflow-tooltip />
        <el-table-column align="right" label="点赞" prop="zan_num" header-align="center" width="80" show-overflow-tooltip />
        <el-table-column align="right" label="评论" prop="comment_num" header-align="center" width="80" show-overflow-tooltip />
        <el-table-column align="right" label="收藏" prop="collect_num" header-align="center" width="80" show-overflow-tooltip />
        <el-table-column align="right" label="浏览量" prop="browse_num" header-align="center" width="80" show-overflow-tooltip />
        <el-table-column align="right" label="投放花费" prop="invest_num" header-align="center" width="80" show-overflow-tooltip
                         :formatter="formatNumber" />
        <el-table-column align="right" label="维护花费" prop="maintenance_num" header-align="center" width="80" show-overflow-tooltip
                         :formatter="formatNumber" />
        <el-table-column align="right" label="累计更新" prop="upd_num" header-align="center" width="80" show-overflow-tooltip />
        <el-table-column align='center' width="130" label='操作'>
          <template slot-scope="{row}">
            <div>
              <el-button v-if="userPermissions.indexOf('artist_pic_text_record_edit') > -1" type="text" size="mini"
                         @click="editShowView(row.id)">更新
              </el-button>
              <el-button v-if="userPermissions.indexOf('artist_pic_text_record_delete') > -1" type="text" size="mini"
                         @click="deleteRow(row)">删除
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!--        <br>-->
      <el-row>
        <el-col :span='24' style='text-align: right'>
          <Pagination :limit.sync='pagingData.page_size'
                      :page.sync='pagingData.current_page'
                      :total='pagingData.total'
                      @pagination='getList' />
        </el-col>
      </el-row>

    </div>
    <!--    新增/修改数据 弹窗-->
    <el-dialog title="保存图文数据" :visible.sync="formData.show" append-to-body
               :close-on-click-modal='false' :before-close="closeFormData">
      <el-form v-loading="formData.loading" ref='formData' :model='formData.data' :rules='formData.rules'
               label-width='120px'>
        <el-form-item label='红人' prop='artist_id'>
          <el-select filterable clearable placeholder="红人检索：输入关键字"
                     v-model="formData.data.artist_id">
            <el-option :key="index" :label="item.nickname" :value="item.artist_id" v-for="(item,index) in kolList">
              <span class="float-left"> {{ item.nickname }} </span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label='内容主题' prop='theme'>
          <el-input class="form___input___style" v-model='formData.data.theme' placeholder='请输入内容主题' />
        </el-form-item>
        <el-form-item label='更新日期' prop='upd_at'>
          <el-date-picker v-model="formData.data.upd_at" type="date" placeholder="请选择更新日期" :editable="false"
                          :clearable="false" />
        </el-form-item>
        <el-form-item label='编辑' prop='editor'>
          <el-input class="form___input___style" v-model='formData.data.editor' placeholder='输入编辑人员' />
        </el-form-item>
        <el-form-item label='点赞' prop='zan_num'>
          <el-input class="form___input___style" v-model='formData.data.zan_num' placeholder='点赞数' />
        </el-form-item>
        <el-form-item label='评论' prop='comment_num'>
          <el-input class="form___input___style" v-model='formData.data.comment_num' placeholder='评论数' />
        </el-form-item>
        <el-form-item label='收藏' prop='collect_num'>
          <el-input class="form___input___style" v-model='formData.data.collect_num' placeholder='收藏数' />
        </el-form-item>
        <el-form-item label='浏览量' prop='browse_num'>
          <el-input class="form___input___style" v-model='formData.data.browse_num' placeholder='浏览量' />
        </el-form-item>
        <el-form-item label='投放花费' prop='invest_num'>
          <el-input class="form___input___style" v-model='formData.data.invest_num' placeholder='投放花费' />
        </el-form-item>
        <el-form-item label='维护花费' prop='maintenance_num'>
          <el-input class="form___input___style" v-model='formData.data.maintenance_num' placeholder='维护花费' />
        </el-form-item>
        <el-form-item label='累计更新' prop='upd_num'>
          <el-input class="form___input___style" v-model='formData.data.upd_num' placeholder='累计更新' />
        </el-form-item>
      </el-form>
      <div slot='footer' class='dialog-footer'>
        <el-button type='primary' @click='onSubmit' :disabled='formData.loading' :loading='formData.btnLoading'>确 定
        </el-button>
        <el-button @click='closeFormData'>取 消</el-button>
      </div>
    </el-dialog>
    <!--    导入弹窗-->
    <import-table :visible.sync='openImport' @imported='handleQuery' />
  </div>
</template>
<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout.vue'
import ArtistSearch from '@/components/artist/ArtistSearch.vue'
import GroupSelect from '@/pages/team/components/GroupSelect.vue'
import Contextmenu from '@/pages/kolModel/components/Contextmenu.vue'
import { mapGetters } from 'vuex'
import ExportBtn from '@/components/export/ExportBtn.vue'
import importTable from '@/pages/analysis_basic/artist_pic_text_record/importTable'
import { parseTime } from '@/utils'
import SelectArtist from '@/components/select/artist.vue'

export default {
  name: 'artistPicTextRecord',
  components: {
    SelectArtist, PageHeaderLayout, ArtistSearch, GroupSelect, Contextmenu, ExportBtn, importTable
  },
  computed: {
    ...mapGetters(['userPermissions'])
  },
  data() {
    return {
      dataList: [],
      pagingData: {
        page_size: 20,
        current_page: 1,
        total: 0
      },
      selectInfo: { artist_id: null, keywords: null, group_ids: [] },
      kolList: [],
      openImport: false,
      isLoading: false,
      visible: false,
      file: [],
      formData: {
        show: false,
        loading: false,
        btnLoading: false,
        data: { upd_at: null },
        // 表单校验
        rules: {
          artist_id: [{ required: true, message: '红人Id不能为空', trigger: 'blur' }],
          theme: [{ required: true, message: '内容主题不能为空', trigger: 'blur' }]
        }
      },
      delIds: []
    }
  },
  methods: {
    parseTime,
    async getKol() {
      this.kolList = await this.$api.modelGetKolList()
    },
    exportDownload: async function() {
      try {
        const isFileSaverSupported = !!new Blob
        if (isFileSaverSupported) {
          const searchCondition = this.handleSearchCondition()
          Object.assign(searchCondition, { is_export: 1 })
          const response = await this.$api.artistPicTextRecordExportList(searchCondition)
          const name = `红人图文数据模板`
          this.$refs[`refExportTemplate`].exportSaveXlsx(response, name)
        }
      } catch (e) {
        this.$message.warning('浏览器不支持导出文件')
      }
    },
    addShowView() {
      this.formData.show = true
      const d = new Date()
      const m = (Number(d.getMonth() + 1) < 10 ? '0' + Number(d.getMonth() + 1) : d.getMonth() + 1)
      const day = d.getDay() < 10 ? '0' + d.getDay() : d.getDay()
      this.formData.data.upd_at = d.getFullYear() + '-' + m + '-' + day
    },
    editShowView: async function(id) {
      if (!id) {
        this.$message.error('缺少主键id')
        return false
      }
      const data = await this.$api.artistPicTextRecordInfo(id)
      this.formData.show = true
      this.formData.data = data.info || {}
    },
    onSubmit() {
      this.$refs['formData'].validate(async (valid) => {
        this.formData.loading = true
        if (valid) {
          // 获取红人昵称
          const option = this.kolList.find(item => item.artist_id === this.formData.data.artist_id)
          this.formData.data.nickname = option.nickname
          // 保存数据
          let res = {}
          if (this.formData.data.id) {
            res = await this.$api.artistPicTextRecordUpdate(this.formData.data)
          } else {
            res = await this.$api.artistPicTextRecordCreate(this.formData.data)
          }
          if (res.id) {
            this.$message.success('保存成功!')
            this.closeFormData()
            await this.getList()
          } else {
            this.$message.error('保存失败!')
          }
        } else {
          return false
        }
        this.formData.loading = false
      })
    },
    deleteRow(row) {
      if (!row.id) {
        this.$message.error('缺少主键id')
        return false
      }
      this.$confirm(`确认删除【红人：${row.nickname}】的【内容主题：${row.theme}】数据吗？无法恢复！！！`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const ret = await this.$api.artistPicTextRecordDel(row.id)
        if (ret) {
          this.$message.success('删除成功')
          await this.getList()
        } else {
          this.$message.success('删除失败')
        }
      }).catch(() => {
      })
    },
    closeFormData() {
      this.formData.show = false
      this.formData.btnLoading = false
      this.formData.data = { upd_at: null }
    },
    handleQuery() {
      this.pagingData.current_page = 1
      this.getList()
    },
    handleSearchCondition() {
      const condition = {}
      Object.keys(this.selectInfo).forEach((field) => {
        if (this.selectInfo[field]) {
          condition[field] = this.selectInfo[field]
        }
      })
      return condition
    },
    getList: async function() {
      this.isLoading = true
      const searchCondition = this.handleSearchCondition()
      // 合并
      Object.assign(searchCondition, this.pagingData)
      const { list, page_info } = await this.$api.artistPicTextRecordList(searchCondition)
      this.dataList = list
      this.pagingData = page_info
      this.isLoading = false
    },
    formatNumber(row, col) {
      return this.$utils.numberFormat(row[col.property], 2, '.', ',', 'round')
    },
    handleDept(val) {
      if (val && val.length > 0) {
        this.selectInfo.group_ids = val
      } else {
        this.selectInfo.group_ids = null
      }
      this.handleQuery()
    },
    handleSelectionChange: function(selection) {
      // 复选框事件
      if (selection.length) {
        this.delIds = selection.map(item => item.id)
      } else {
        this.delIds = []
      }
    },
    batchDelete: function() {
      // 批量删除
      if (!this.delIds.length) {
        this.$message.error('缺少主键id包')
        return false
      }
      this.$confirm(`确认删除【${this.delIds.length}条】数据吗？无法恢复！！！`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const ret = await this.$api.artistPicTextRecordBatchDel(this.delIds)
        if (ret) {
          this.$message.success('批量删除成功')
          await this.getList()
        } else {
          this.$message.success('批量删除失败')
        }
      }).catch(() => {
      })
      // if (this.delIds.length) {
      //   console.log(this.delIds)
      // }
    }
  },
  mounted() {
    this.handleQuery()
    this.getKol()
  }
}
</script>

<style lang="scss" scoped>
.addNewBox {
  width: 90%;
  margin: 0 auto;

  > * {
    padding: 10px;
  }
}


.form___input___style {
  width: 40%;
}
</style>

